import { menuIcons } from './menuIcons';

const menuCashflow = [
  {name:"Net Cashflow",content:[]},
  {name:"Net Cash Allocation",content:[]},
  {name:"Net Cash Projections",content:[]},
  {name:"Income",content:[]},
  {name:"Return on Savings & Investment",content:[]},
  {name:"Expense",content:[]},
  {name:"Liability Payback",content:[]},
]


const menuGoals = [
  {name:"Overview",content:[]},
  {name:"Steps to realize Goals",content:[]},
  {name:"Projections",content:[]},
]

const menuMyPortfolio = [
  {name:"Overview",content:[]},
  {name:"Current Positions",content:[]},
  {name:"Transactions",content:[]},
  {name:"Asset Allocation",content:[]},
  {name:"Portfolio vs Benchmark",content:[]},
  {name:"Asset Analytics",content:["Trend","Trend Table","Technical Indicators","Performance","Volatility","Correlation",]},
  // {name:"Insights",content:[]}
]

const menuLiabilities = [
  {name:"Overview",content:[]},
  {name:"Steps to manage Liabilities",content:[]},
  {name:"Payment Overview",content:[]},
  {name:"Allocation",content:[]},
  {name:"Projections",content:[]},
  {name:"Amortization Schedule",content:[]},
]

const menuAssets = [
  {name:"Overview",content:[]},
  {name:"Steps to grow Assets",content:[]},
  {name:"Allocation",content:[]},
  {name:"Projections",content:[]},
  {name:"Simulated Projections",content:[]},
]
const menuNetworth = [
  {name:"Overview",content:[]},
  {name:"Steps to grow Networth",content:[]},
  {name:"Projections",content:[]},
  {name:"Breakdown",content:[]},
  
]
const menuInvestmentPreference = [
  {name:"Market Region",content:[]},
  {name:"Time Horizon",content:[]},
  {name:"Asset Allocation",content:[]}
]
const menuMyFinancials = [
    { icon: menuIcons?.Profile, name:"Overview",label: 'Overview',link:"Overview",content:[]},
    {icon: menuIcons?.Health,name:"Financial Wellness",label:"Financial Wellness",link:"FinancialHealth"},
    // {icon: menuIcons?.Health,name:"Economy & Market Impact",label:"Economy & Market Impact",link:"MarketImpact"},
    // {icon: menuIcons?.Goals,name:"Goals",label:"Goals",link:"Goals",content:[],menuOptions:menuGoals},
    {icon: menuIcons?.Networth,name:"Networth",label: 'Networth',link:"Networth",content:[],menuOptions:menuNetworth},
    {icon: menuIcons?.Asset,name:"Assets",label: 'Assets',link:"Assets",content:[],menuOptions:menuAssets},
    {icon: menuIcons?.Liability,name:"Liabilities",label: 'Liabilities',link:"Liabilities",content:[],menuOptions:menuLiabilities},
    // {icon:menuIcons?.Portfolio,label:"Portfolio",name:"Portfolio",link:"Portfolio",content:["Overview","Current Positions","Transactions","Asset Allocation","Portfolio vs Benchmark","Assets Trend","Assets Trend Table","Technical Indicators","Performance","Volatility","Correlation","Report","Insights"],menuOptions:menuMyPortfolio},
    {icon: menuIcons?.Cashflow,name:"Cashflow",label: 'Cashflow',link:"Cashflow",content:[],menuOptions:menuCashflow},
    // {icon: menuIcons?.InvestmentPreferences,name:"Investment Preferences",label:"Preference",link:"InvestmentPreferences",content:[],menuOptions:menuInvestmentPreference},
    // {icon: menuIcons?.RiskManagement, name:"Risk Management",label:"Risk",link:"RiskManagement",content:["Risk Tolerance","Risk Mitigation Option","Crisis Management"],menuOptions:menuRiskManagement},
    // {icon: menuIcons?.Scenarios, name:"Scenarios",label:"Scenarios",link:"Scenarios",content:[]},
  ]

const menuPortfolio = [
    {icon:menuIcons?.Portfolio,label:"Portfolio",name:"Portfolio",link:"Portfolio",content:["Overview","Current Positions","Transactions","Asset Allocation","Portfolio vs Benchmark","Assets Trend","Assets Trend Table","Technical Indicators","Performance","Volatility","Correlation","Report","Insights"],menuOptions:menuMyPortfolio},
    {icon: menuIcons?.InvestmentPreferences,name:"Investment Preferences",label:"Preference",link:"InvestmentPreferences",content:[],menuOptions:menuInvestmentPreference},
    // {icon: menuIcons?.RiskManagement, name:"Risk Management",label:"Risk",link:"RiskManagement",content:["Risk Tolerance","Risk Mitigation Option","Crisis Management"],menuOptions:menuRiskManagement},
    // {icon: menuIcons?.Scenarios, name:"Scenarios",label:"Scenarios",link:"Scenarios",content:[]},
  ]

const menuStocks = [
    { name: "Overview", content: ["Profile"] },
    { name: "Stats", content: ["Stats vs Industry", "Stats vs Peers"] },
    { name: "Business & Shareholding", content: ["Business", "Management", "Shareholding", "Insider Transactions", "Senate Transactions"] },
    { name: "Charts", content: ["Technical Chart", "Price vs Benchmark", "Price vs Peers", "Price vs Financials", "Price vs Economy", "Peer Bar & Pie", "Peer Scatter"] },
    { name: "Technicals", content: ["Indicators", "Performance", "Volatility", "Correlation", "Beta"] },
    { name: "Financials", content: ["Statements", "Ratios", "Revenue Segment", "Common Size Statements", "Statement Breakdown", "Earning Trends", "Profitablity", "Capital Structure", "vs Price"] },
    { name: "Value", content: ["Price Multiple", "EV Multiple", "DCF", "Dividend"] },
    { name: "Derivative", content: ["Options"] },
    { name: "Peers", content: ["Peer Profile", "Stats vs Peers", "Price vs Peers", "Financials vs Peers", "Financial Ratios vs Peers", "Performance", "Volatility", "Correlation", "Beta", "Scatter"] },
    { name: "News & Events", content: ["News", "Press Release"] },
    { name: "Transcripts & Filings", content: ["Earning Transcripts", "Security Exchange Filings"] },
  ];
  
  const menuCrypto = [
    { name: "Overview", content: ["Profile"] },
    { name: "Chart", content: ["Technical Chart", "Price vs Benchmark", "Price vs Peers", "Price vs Economy"] },
    { name: "Technicals", content: ["Indicators", "Performance", "Volatility", "Correlation", "Beta"] },
    { name: "News", content: [] },
  ];
  
  const menuETF = [
    { name: "Overview", content: ["Profile"] },
    { name: "Holdings", content: ["Asset Allocation", "Top Holdings", "Holdings"] },
    { name: "Chart", content: ["Technical Chart", "Price vs Benchmark", "Price vs Peers", "Price vs Economy"] },
    { name: "Technicals", content: ["Indicators", "Performance", "Volatility", "Correlation", "Beta"] },
    { name: "News", content: [] }
  ];

  const menuEcon = [
    { name: "Overview", content: [] },
    { name: "Global", content: [] },
    { name: "Macro Econ Indicators", content: ["Interest Rates", "Inflation", "Monetary", "Business Indicators", "Employment", "National Accounts"] },
    { name: "vs Market", content: [] },
    { name: "Map", content: [] },
    { name: "Calendar", content: [] }
  ];
  

const menuTopInvestors = [
  {name:"Overview",content:[]},
  {name:"Holdings",content:[]},
  {name:"Analytics",content:[]},
]
const menuPortfolioGuide = [
  {name:"Portfolio Builder",content:[]},
  {name:"Portfolio Management",content:[]},
  {name:"Risk Management",content:[]}
]

const menuNews = [
  {name:"Stocks",content:[]},
  {name:"Crypto",content:[]},
  {name:"Forex",content:[]},
  {name:"General",content:[]},
]

const menuCalendar = [
  {name:"Earnings",content:[]},
  {name:"Dividend",content:[]},
  {name:"IPO",content:[]},
  {name:"Economy",content:[]},
]
const menuTradingActivities = [
  {name:"Congress Trading Activitis",content:[]}
]
const menuFilings = [
  {name:"Security Exchange Filings",content:[]}
]
const menuNewsEvents = [
  {icon:  menuIcons.News,label:"News",name:"News",link:"News",menuOptions:menuNews},
  {icon:  menuIcons.Calendar,label:"Calendar",name:"Calendar",link:"Calendar",menuOptions:menuCalendar},
  {icon:  menuIcons.MandA,label:"M&A" ,name:"Merger & Acquisitions",link:"MandA",menuOptions:[]},
  {icon:  menuIcons.Filings,label:"Filings" ,name:"Filings",link:"Filings",menuOptions:menuFilings},
  {icon: menuIcons.TradingActivities,label:"Trading Activities",name:"Trading Activities",link:"TradingActivities",menuOptions:menuTradingActivities}
]


const menuAnalytics = [
  { icon: menuIcons.Ticker, label: 'Ticker', name: 'Ticker',link:"Ticker"},
  { icon: menuIcons.Industry, label: 'Sector & Industry', name: 'Sector & Industry',link:"Industry" },
  { icon: menuIcons.Market, label: 'Market', name: 'Market',link:"Market"},
  { icon: menuIcons.Economy, label: 'Economy', name: 'Economy',link:"Economy"},
  { icon: menuIcons["Top Investors"], label: 'Top Investors', name: 'Top Investors',link:"Investors"}
]

const menuMarket = [
  { name: "Market Today", content: [] },
  { name: "Trend Chart", content: [] },
  { name: "Trend Table", content: [] },
  { name: "Indicators", content: [] },
  { name: "Performance", content: [] },
  { name: "Volatility", content: [] },
  { name: "Correlation", content: [] },
  { name: "Beta", content: [] },
  { name: "Constituents", content: [] },
  { name: "Scatter", content: [] },
  { name: "Yield Curve", content: [] },
  { name: "Market Breadth", content: [] },
  { name: "Heatmap", content: [] },
  { name: "Exchange Rate", content: [] },
  { name: "Guide", content: ["Market Analysis"] }
];


const menuResource = [
  { icon: menuIcons?.Guide, label: 'Guide', name: 'Guide',link:"Guide"},
    { icon: menuIcons?.Learn, label: 'Learn', name: 'Learn' ,link:"Learn"},
    { icon: menuIcons?.Glossary, label: 'Glossary', name: 'Glossary',link:"Glossary" },
    // { icon: menuIcons?.["Mind Map"], label: 'Mind Map', name: 'MindMap' ,link:"MindMap"},
    // { icon: menuIcons?.Doodle, label: 'Doodle', name: 'Doodle',link:"Doodle" },
  ]

const menuWhiteBoard = [
  { icon: menuIcons?.["Mind Map"], label: 'Mind Map', name: 'MindMap' ,link:"MindMap"},
    { icon: menuIcons?.Doodle, label: 'Doodle', name: 'Doodle',link:"Doodle" },
]

const menuScreener = [
  {name: "Stocks", link: "Stocks", label: "Stocks",icon:menuIcons.Stocks},
  {name: "Crypto", link: "Crypto", label: "Crypto",icon:menuIcons.Crypto},
  {name: "Etf", link: "Etf", label: "Etf",icon:menuIcons.Etf},
  {name: "Bonds", link: "Bonds", label: "Bonds",icon:menuIcons.Bonds},
  {name: "Forex", link: "Forex", label: "Forex",icon:menuIcons.Forex},
];



const menuTechnicals = [
  // {name: "Multi Trend", content: []},
  {name: "Indicators", content: []},
  {name: "Performance", content: []},
  {name: "Volatility", content: []},
  {name: "Correlation", content: []},
  {name: "Beta", content: []},
 
];

const menuVisuals = [
  {name: "Scatter", content: []},
  {name: "Bar & Pie", content: []},
  {name: "Heatmap", content: []}
]
const menuChart = [
  {name: "Technical Chart", content: []},
  {name:"Price vs Benchmark",content:[]},
  {name: "Price vs Peers", content: []},
  {name: "Price vs Economy", content: []},
]


const menuTrade = [
  {name: "Order", link: "Order", label: "Order",icon:menuIcons.Order,menuOptions:[]},
  {name: "Transactions", link: "Transactions", label: "Transactions",icon:menuIcons.Transactions,menuOptions:[]},
  {name: "Chart", link: "Chart", label: "Chart",icon:menuIcons.Chart,menuOptions:menuChart},
  // {name: "Portfolio Fit", link: "PortfolioFit", label: "Portfolio Fit",icon:menuIcons.Fit,menuOptions:[]},
  {name: "Trade Conditions", link: "TradeConditions", label: "Trade Conditions",icon:menuIcons.Checklist,menuOptions:[]},
  {name: "Technicals", link: "Technicals", label: "Technicals",icon:menuIcons?.Technicals,menuOptions:menuTechnicals},
]


const menuOpportunities = [
  {name: "Portfolio Fit", link: "PortfolioFit", label: "Portfolio Fit",icon:menuIcons.Fit,menuOptions:[]},
  {name: "Investment", link: "Investment", label: "Investment",icon:menuIcons.Investment,menuOptions:[]},
  {name: "Trading", link: "Trading", label: "Trading",icon:menuIcons.Trading,menuOptions:[]},
 
]

const menuReport = [
  {name: "Autonomy Reports", link: "AutonomyReports", label: "TS Reports",icon:menuIcons.Report,menuOptions:[]},
  // {name:"Report Builder",link:"ReportBuilder",label:"Builder",icon:menuIcons["Report Builder"],menuOptions:[]}
  ]


const menuTakeStock = ["Home","About","Contact","Product","Pricing","Support","Terms","Disclaimer"]

const menuFinancialProducts = [
  {name: "Mortgages", link: "Mortgages", label: "Mortgages", icon: menuIcons.Report, menuOptions: []},
  {name: "Home Insurance", link: "HomeInsurance", label: "Home Insurance", icon: menuIcons.Report, menuOptions: []},
  {name: "Life Insurance", link: "LifeInsurance", label: "Life Insurance", icon: menuIcons.Report, menuOptions: []},
  {name: "Car Insurance", link: "CarInsurance", label: "Car Insurance", icon: menuIcons.Report, menuOptions: []},
  {name: "Credit Cards", link: "CreditCard", label: "Credit Card Reports", icon: menuIcons.Report, menuOptions: []},
  {name: "Student Loans", link: "StudentLoans", label: "Student Loans", icon: menuIcons.Report, menuOptions: []},
  {name: "Savings Accounts", link: "SavingsAccount", label: "Savings Account", icon: menuIcons.Report, menuOptions: []},
 {name: "Pesonal Loans", link: "PersonalLoans", label: "Loans", icon: menuIcons.Report, menuOptions: []},
 
]

const menuAskProfessional = [
  { name: "My Financial Wellness Team", link: "", label: "My Financial Wellness Team", icon: menuIcons.Report, menuOptions: [] },
  { name: "Financial Advisor", link: "FinancialAdvisor", label: "Financial Advisor", icon: menuIcons.Report, menuOptions: [] },
  // { name: "Financial Planner", link: "FinancialPlanner", label: "Financial Planner", icon: menuIcons.Report, menuOptions: [] },
  // { name: "Wealth Manager", link: "WealthManager", label: "Wealth Manager", icon: menuIcons.Report, menuOptions: [] },
  // { name: "Portfolio Manager", link: "PortfolioManager", label: "Portfolio Manager", icon: menuIcons.Report, menuOptions: [] },
  // { name: "Investment Advisor", link: "InvestmentAdvisor", label: "Investment Advisor", icon: menuIcons.Report, menuOptions: [] },
  { name: "Mortgage Advisor", link: "MortgageAdvisor", label: "Mortgage Advisor", icon: menuIcons.Report, menuOptions: [] },
  { name: "Insurance Advisor", link: "InsuranceAdvisor", label: "Insurance Advisor", icon: menuIcons.Report, menuOptions: [] },
  // { name: "Loan Advisor", link: "LoanAdvisor", label: "Loan Advisor", icon: menuIcons.Report, menuOptions: [] },
  // { name: "Investment Analyst", link: "InvestmentAnalyst", label: "Investment Analyst", icon: menuIcons.Report, menuOptions: [] },
  // { name: "Trade Analyst", link: "TradeAnalyst", label: "Trade Analyst", icon: menuIcons.Report, menuOptions: [] },
  // { name: "Form", link: "form", label: "Trade Analyst", icon: menuIcons.Report, menuOptions: [] },
];

function Icon({imgSrc,height="25px",width="25px"}){
  return(<div style={{width:width,height:height}}>
   <img src={imgSrc} style={{objectFit:"cover"}} width={"100%"} height={"100%"}>
     </img></div>)
 }

 const navLinks = [
  {name:"Home",link:"Home",icon:menuIcons?.Home},
  {name:"Ask AI",link:"AskAI",icon:menuIcons?.ChatAI},
  {name:"Ask Professional",link:"AskProfessional",menu:menuAskProfessional,icon:menuIcons?.AskProfessional},
  {name:"My Financials",link:"MyFinancials",menu:menuMyFinancials,icon:menuIcons?.Asset},
  {name:"Scenarios",link:"Scenarios",icon:menuIcons?.Visuals},
  {name:"My Vault",link:"MyVault",icon:menuIcons?.Vault},
  {name:"Financial Products",link:"FinancialProducts",menu:menuFinancialProducts,icon:menuIcons?.Product},
  {name:"Opportunities",link:"Opportunities",menu:menuOpportunities,icon:menuIcons?.Opportunity},
  {name:"Charts/Trading",link:"Trade",menu:menuTrade,icon:menuIcons?.Trade},
  {name:"Analytics",link:"Analytics",menu:menuAnalytics,icon:menuIcons?.Analytics},
{name:"Screener",link:"Screener",menu:menuScreener,icon:menuIcons?.Filter},
{name:"News/Events",link:"NewsEvents",menu:menuNewsEvents,icon:menuIcons?.Calendar},
// {name:"Reports",link:"Report",menu:menuReport,icon:menuIcons?.Report},
{name:"Reports",link:"Report",icon:menuIcons?.Report},
{name:"Education",link:"Resource",menu:menuResource,icon:menuIcons?.Education},
]

const selectedNames = ["Home","Ask AI","My Financials"];
// export const navLinksSelectedDefault = navLinks.filter((item) => selectedNames.includes(item.name));

export const navLinksSelectedDefault = ["Home","AskAI","MyFinancials"];
// {category:"Automate", name:"Automate",link:"Automate",icon:menuIcons?.Automate},
// {category:"Home", name:"Automate",link:"Automate",icon:menuIcons?.Automate},
export const navLinkCategories = [
  {category:"Home",name:"Overview",link:"Home",icon:menuIcons?.Profile, display:true},
  {category:"Home", name:"Ask Quinn",link:"AskAI",icon:menuIcons?.ChatAI, display:true},
  {category:"Home", name:"To-dos",link:"Todos",icon:menuIcons?.Todo, display:true},
  {category:"Home",name:"Vault",link:"MyVault",icon:menuIcons?.Vault, display:true},
  {category:"Home", name:"Financials",link:"MyFinancials",menu:menuMyFinancials,icon:menuIcons?.Asset, display:true},
  {category:"Home", name:"Portfolio",link:"Portfolio",icon:menuIcons?.Portfolio, display:true},
  {category:"Home", name:"Goals",link:"Goals",icon:menuIcons?.Goals, display:true},
  {category:"Home", name:"Scenarios",link:"Scenarios",icon:menuIcons?.Scenarios, display:true},
  {category:"Marketplace", name:"Ask Professional",link:"AskProfessional",menu:menuAskProfessional,icon:menuIcons?.AskProfessional,comment:"Demo",display:false},
  {category:"Marketplace", name:"Financial Products",link:"FinancialProducts",menu:menuFinancialProducts,icon:menuIcons?.Product,comment:"Demo",display:false},
  {category:"Investment",name:"Opportunities",link:"Opportunities",menu:menuOpportunities,icon:menuIcons?.Opportunity,display:false},
  {category:"Investment",name:"Charts/Trading",link:"Trade",menu:menuTrade,icon:menuIcons?.Trade,display:false},
  {category:"Investment", name:"Analytics",link:"Analytics",menu:menuAnalytics,icon:menuIcons?.Analytics,display:false},
{category:"Investment",name:"Screener",link:"Screener",menu:menuScreener,icon:menuIcons?.Filter,display:false},
{category:"Investment",name:"News/Events",link:"NewsEvents",menu:menuNewsEvents,icon:menuIcons?.Calendar,display:false},
{category:"Community",name:"Social",link:"Social",icon:menuIcons?.Social,comment:"Demo",display:false},
{category:"Community",name:"Education",link:"Resource",menu:menuResource,icon:menuIcons?.Education,display:false},
{category:"Home",name:"Reports",link:"Report",icon:menuIcons?.Report, display:true},
// {category:"Autonomy",name:"Sitemap",link:"Sitemap",icon:menuIcons?.Flow},
// {category:"Autonomy",name:"Support",link:"Support",icon:menuIcons?.Health},
// {category:"Autonomy",name:"About Us",link:"About",icon:menuIcons?.Profile},
// {category:"Autonomy",name:"Features",link:"Features",icon:menuIcons?.Settings},
// {category:"Autonomy",name:"Contact",link:"Contact",icon:menuIcons?.AskProfessional},
// {category:"Autonomy",name:"Terms",link:"Terms",icon:menuIcons?.Report},
// {category:"Autonomy",name:"Disclaimer",link:"Disclaimer",icon:menuIcons?.Report},
]

const navLinkAdvisor = [
  {category:"Home",name:"Clients",link:"Home",icon:menuIcons?.Clients, display:true},
  {category:"Home", name:"Ask Quinn",link:"AskAI",icon:menuIcons?.ChatAI, display:true},
  // {category:"Home", name:"To-dos",link:"Todos",icon:menuIcons?.Todo},
  // {category:"Home",name:"Overview",link:"Clients",icon:menuIcons?.Clients},
  // {category:"Home",name:"Prospects",link:"Prospects",icon:menuIcons?.Profile},
  {category:"Home",name:"Pulse AI",link:"Pulse",icon:menuIcons?.Pulse, display:true},
  // {category:"Home",name:"AI Paraplanner",link:"AIParaplanner",icon:menuIcons?.Flow},
  {category:"Home",name:"AI Paraplanner",link:"Planning",icon:menuIcons?.Planning, display:true },
  {category:"Home",name:"Meeting & Events",link:"Meeting",icon:menuIcons?.Calendar, display:true},
  // {category:"Home",name:"Client Vault",link:"ClientVault",icon:menuIcons?.Vault, display:true},
  // {category:"Clients",name:"Reports",link:"Report",menu:menuReport,icon:menuIcons?.Report},
  // {category:"Marketplace & Community", name:"Team",link:"AskProfessional",icon:menuIcons?.AskProfessional},
  // {category:"Marketplace & Community", name:"Financial Products",link:"FinancialProducts",menu:menuFinancialProducts,icon:menuIcons?.Product},
  // {category:"Marketplace & Community",name:"Social",link:"Social",icon:menuIcons?.Social},
//   {category:"News & Analytics",name:"Opportunities",link:"Opportunities",menu:menuOpportunities,icon:menuIcons?.Opportunity},
//   {category:"News & Analytics",name:"Charts/Trading",link:"Trade",menu:menuTrade,icon:menuIcons?.Trade},
//   {category:"News & Analytics", name:"Analytics",link:"Analytics",menu:menuAnalytics,icon:menuIcons?.Analytics},
// {category:"News & Analytics",name:"Screener",link:"Screener",menu:menuScreener,icon:menuIcons?.Filter},
// {category:"News & Analytics",name:"News/Events",link:"NewsEvents",menu:menuNewsEvents,icon:menuIcons?.Calendar},
  // {category:"Autonomy",name:"Sitemap",link:"Sitemap",icon:menuIcons?.Flow},
  // {category:"Autonomy",name:"Support",link:"Support",icon:menuIcons?.Health},
  // {category:"Autonomy",name:"About Us",link:"About",icon:menuIcons?.Profile},
  // {category:"Autonomy",name:"Features",link:"Features",icon:menuIcons?.Settings},
  // {category:"Autonomy",name:"Contact",link:"Contact",icon:menuIcons?.AskProfessional},
  // {category:"Autonomy",name:"Terms",link:"Terms",icon:menuIcons?.Report},
  // {category:"Autonomy",name:"Disclaimer",link:"Disclaimer",icon:menuIcons?.Report},

]

export const navCompany = [
  {category:"Autonomy",name:"Sitemap",link:"Sitemap"},
  {category:"Autonomy",name:"About Us",link:"About"},
  {category:"Autonomy",name:"Features",link:"Features"},
  {category:"Autonomy",name:"Contact",link:"Contact"},
  {category:"Autonomy",name:"Terms",link:"Terms"},
  {category:"Autonomy",name:"Disclaimer",link:"Disclaimer"},
]
 // {name:"Ask Professional",link:"AskProfessional",icon:menuIcons?.AskProfessional},

const groupedNavLinks = navLinkCategories.reduce((acc, link) => {
  if (!acc[link.category]) acc[link.category] = [];
  acc[link.category].push(link);
  return acc;
}, {});

// Advisor menu configurations
const menuClients = [
  {name: "Overview", content: []},
  {name: "Client List", content: []},
  {name: "Client Analytics", content: []},
  {name: "Client Reports", content: []}
];

const menuPulse = [
  {name: "News Pulse", content: []},
  {name: "Asset Pulse", content: []},
  {name: "Market Pulse", content: []},
  {name: "Cashflow Pulse", content: []}
];

const menuAdvisorScenarios = [
  {name: "Client Selection", content: []},
  {name: "Current Scenario", content: []},
  {name: "Scenario Comparison", content: []},
  {name: "Scenario Analytics", content: []}
];

const menuAdvisorProducts = [
  {name: "Product Overview", content: []},
  {name: "Product Catalog", content: []},
  {name: "Product Analytics", content: []},
  {name: "Product Recommendations", content: []}
];

const menuAdvisor = [
  { icon: menuIcons?.Profile, name: "Overview", label: "Overview", link: "Overview", content: [] },
  { icon: menuIcons?.Clients, name: "Clients", label: "Clients", link: "Clients", content: [] },
  { icon: menuIcons?.Portfolio, name: "Portfolios", label: "Portfolios", link: "Portfolios", content: [] },
  { icon: menuIcons?.Analytics, name: "Analytics", label: "Analytics", link: "Analytics", content: [] },
  { icon: menuIcons?.Report, name: "Reports", label: "Reports", link: "Reports", content: [] },
];

// Group advisor nav links by category
const groupedNavLinkAdvisor = navLinkAdvisor.reduce((acc, link) => {
  if (!acc[link.category]) acc[link.category] = [];
  acc[link.category].push(link);
  return acc;
}, {});

export {
  groupedNavLinkAdvisor,
  groupedNavLinks,
  menuAdvisor,
  menuAnalytics,
  menuCashflow,
  menuCrypto,
  menuEcon,
  menuETF,
  menuGoals,
  menuMarket,
  menuMyFinancials,
  menuMyPortfolio,
  menuNewsEvents,
  menuOpportunities,
  menuReport,
  menuResource,
  menuScreener,
  menuStocks,
  menuTakeStock,
  menuTrade,
  navLinkAdvisor,
  navLinks,
};